// Rutas de la API
const APIAltaClientesColombia = 'https://ws.compusoluciones.com/wsAltaClientesCOL';
//const APIAltaClientesColombia = 'https://localhost:44332';
const APIIntelisis = 'https://aplicws.compusoluciones.com/AltaCteCol/api';

export const URL = {
    URL: APIAltaClientesColombia,
}

export const LOGIN = {
    ValidarUsuario: APIAltaClientesColombia + '/login/validarusuario/',
}

export const HISTORIAL = {
    Clientes: APIAltaClientesColombia + '/historial/clientes',
    DescargarArchivo: APIAltaClientesColombia + '/historial/descargararchivo',
    ListaFiltro: APIAltaClientesColombia + '/historial/listafiltro/'
}

export const ALTA = {
    Altas: APIAltaClientesColombia + '/alta/altas',
    Revisar: APIAltaClientesColombia + '/alta/revisar',
    AltaIntelisis: APIAltaClientesColombia + '/alta/registraraltaintelisis'
}

export const REGISTRAR = {
    SubirRUT: APIAltaClientesColombia + '/registrar/subirrut',
    RegistrarCliente: APIAltaClientesColombia + '/registrar/registrarcliente',
    SubirDocs: APIAltaClientesColombia + '/registrar/subirdocs',
    SolicitudPendiente: APIAltaClientesColombia + '/registrar/solicitudpendiente/'
}

export const CONFIGURAR = {
    ListaRegimenes: APIAltaClientesColombia + '/configurarregimenes/listaregimenes',
    ListaRegimenesIntelisis: APIAltaClientesColombia + '/configurarregimenes/listaregimenesintelisis',
    NuevoRegimen: APIAltaClientesColombia + '/configurarregimenes/nuevoregimen',
    QuitarRegimen: APIAltaClientesColombia + '/configurarregimenes/quitarregimen',
    ActualizarRegimen: APIAltaClientesColombia + '/configurarregimenes/actualizarregimen',
}

export const INTELISIS = {
    Login: APIIntelisis + '/login',
    BuscarCliente: APIIntelisis + '/Cte/',
    RegistrarIntelisis: APIIntelisis + '/Cte',
    RegistrarAnexo: APIIntelisis + '/Cte/Anexo',
}